<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
      <h1 class="">Amudei All Torah Sponsorship</h1>
      <div class="amerudi__subtitle">Your donation of $1800 or more makes you an Amudei All Torah member, supporting our vision of making Torah learning easily accessible to a wide range of individuals, combining highly curated content with the latest technology. </div>
        <PaymentForm class="form-horizontal">
          <FormSection title="Sponsorship Levels">
            <div>
              <AmountSelectorList />
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="Ways To Give">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly />
            </div>
          </FormSection>

          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>  
            <br />
            <div>
              <FormRow inline>
                <FormCol
                  field="custom.specialInstructions"
                  width="half"
                  :showLabel="false"
                >
                  <label class="control-label">Listing name for Dedication</label>
                  <FormInput type="text" />
                </FormCol>
              </FormRow>
            </div>
            <FormRow>
              <NewsletterSubscribe text="Sign me up for the Newsletter" />
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  ref,
  defineComponent,
  onMounted,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, getValue, form, testMode } = usePaymentForm();

    setValue(
      "callback",
      testMode
        ? "https://admin-outorah.oudev.org/amudeiDonationCallback"
        : "https://admin.outorah.org/amudeiDonationCallback"
    );

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      submit,
      getValue,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
h2 {
  font-weight: 400;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.form-container.ou-donation-form{
  padding-top: 48px;
  max-width: 750px;

}

.ou-donation-form ::v-deep h2 {
  text-transform: none;
  letter-spacing: normal;
  font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 22px;
color: #080F16;
  margin-bottom: 16px;
}
.ou-donation-form ::v-deep .holder {
  font-family:"proxima-nova","Helvetica Neue",Helvetica,Arial,sans-serif;
}
.frequency ::v-deep  .styled-radio-container--ou-donation.styled-radio-container input[type="radio"]:checked + label{
  background: #04517C;
  padding: 14px 24px;
border-radius: 99px;
font-style: normal;
color: #FDFDFD;
font-weight: 500;
font-size: 14px;
line-height: 18px;
}
.ou-donation-form  ::v-deep  #donate-widget-form-submit{
  background: #04517C;
  padding: 10px 24px;
border-radius: 99px;
font-style: normal;
color: #FDFDFD;
font-weight: 600;
font-size: 14px;
line-height: 18px;
}
.frequency ::v-deep  .styled-radio-container--ou-donation.styled-radio-container input[type="radio"] + label{
  border: 1px solid #04517C;
border-radius: 99px;
  padding: 10px 24px;
font-style: normal;
color: #04517C;
font-weight: 500;
font-size: 14px;
line-height: 18px;
}
.frequency ::v-deep  .styled-radio-container--ou-donation.styled-radio-container .radio-part{
  min-width: auto;
  max-width: 100%;
  flex: 0 1 auto;
  width: auto;
}
.ou-donation-form ::v-deep  .styled-radio-container--ou-donation.styled-radio-container .amount-row{
  min-width: 31%;
    max-width: 31%;
    label{
      flex-flow: column;
      padding: 20px 10px;
      &:hover{
        .label-description{
          color: black;
        }
      }
    }

    input[type="radio"]:checked + label{
      border-color: #04517C;
      background: #04517C;
      color: #FDFDFD;
      .label-description{
        color: #FDFDFD;

      }
    }
    input[type="radio"]:checked + label .label-amount{
      border-color: #04517C;
      background: #04517C;
      color: #FDFDFD;
    }
    .label-amount{
      width: 100%;
    min-width: 100%;
    max-width: 100%;
    background: none;
    padding: 0px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
    text-align: center;
    color: #080F16;
    }
    .label-description{
      font-style: italic;
font-weight: 400;
font-size: 15px;
line-height: 22px;
padding: 8px 0px 0px;
text-align: center;
color: #96999C;
    }
}
label.newsletter__label {
  padding-left: 7px;
}

label.control-label {
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
}

h1{
  font-style: normal;
font-weight: 700;
font-size: 32px;
line-height: 32px;
color: #080F16;
font-family:"proxima-nova","Helvetica Neue",Helvetica,Arial,sans-serif;
padding-bottom: 12px;
margin-bottom: 0px;
}
.amerudi__subtitle{
  font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 23px;
    color: #080F16;
    font-family: "proxima-nova","Helvetica Neue",Helvetica,Arial,sans-serif;
    padding-bottom: 28px;
    margin-bottom: 0px;
}
</style>
